import * as React from "react";
import styled from "styled-components";

import { DateTime } from "luxon";

import { DatePickerDatesGrid } from "../dates-grid";
import { DatePickerMonthSelector } from "../month-selector";

interface IProps {
  currentDate: DateTime;
  firstMonth: boolean;
  innerRef?: React.RefObject<HTMLElement>;
  lastMonth: boolean;
  maxDaysRange?: number;
  onMonthLeft(): void;
  onMonthRight(): void;
  onSelectDate(date: DateTime): void;
  selectedDate?: string;
  selectedMonth: DateTime;
}

const DatePickerCalendarWrapper = styled.div`
  position: absolute;
  width: 270px;
  top: 45px;
  right: 50%;
  transform: translate(50%, 0);
  box-shadow: 0 1px 17px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  background: white;
  z-index: 99;

  @media screen and (max-width: 992px) {
    right: 0;
    transform: 0;
  }
`;

const DatePickerCalendar: React.FC<IProps> = (props) => {
  return (
    <DatePickerCalendarWrapper innerRef={props.innerRef}>
      <DatePickerMonthSelector
        firstMonth={props.firstMonth}
        lastMonth={props.lastMonth}
        onMonthLeft={props.onMonthLeft}
        onMonthRight={props.onMonthRight}
        selectedMonth={props.selectedMonth}
      />
      <DatePickerDatesGrid
        currentDate={props.currentDate}
        maxDaysRange={props.maxDaysRange}
        onSelectDate={props.onSelectDate}
        selectedDate={props.selectedDate}
        selectedMonth={props.selectedMonth}
      />
    </DatePickerCalendarWrapper>
  );
};

export { DatePickerCalendar };
